/* eslint-disable @typescript-eslint/indent */
/* eslint-disable no-nested-ternary */
import React from 'react';
import Currency from '@components/common/Currrency/Currency';
import { getProductPriceForGuestType } from '@utils/fairPricing';
import Product from '@customTypes/product';
import HotelDetails from '@customTypes/hotel-details';
import useHotSpot from '@hooks/useHotSpot';
import useIsMobile from '@hooks/useIsMobile';

type Props = {
  date: Date | undefined;
  hotelDetails: HotelDetails;
  personType: 'adult' | 'child';
  product: Product;
  fairPricing: boolean;
};

export default function ProductDetailsPrice({
  date,
  hotelDetails,
  personType,
  product,
  fairPricing,
}: Props) {
  const isMobile = useIsMobile();
  const { applyHotSpotDiscountToTotal, isDateWithinVisitWindow } = useHotSpot();

  return (
    <div className="flex flex-col items-start">
      <div
        className={`flex text-21 font-normal font-rp-pn-regular ${
          isMobile ? 'flex-row-reverse' : 'flex-col'
        }`}
      >
        <Currency
          value={getProductPriceForGuestType(product, personType, fairPricing)}
          valueClasses={`leading-4 ${
            date && product.is_hot_spot && isDateWithinVisitWindow(date, hotelDetails)
              ? 'text-rp-disabled text-base line-through'
              : `text-custom-black ${isMobile ? 'text-sm' : 'mt-1 text-22'}`
          }`}
          isoCodeClasses="text-sm font-rp-pn-regular"
        />

        {date &&
        product.is_hot_spot &&
        hotelDetails.hot_spot &&
        isDateWithinVisitWindow(date, hotelDetails) ? (
          <Currency
            value={applyHotSpotDiscountToTotal(
              personType === 'adult' ? +product.adult_price : +product.children_price,
              hotelDetails.hot_spot,
              fairPricing,
            )}
            valueClasses={`text-rp-hot-spot ${
              isMobile ? 'leading-4 mr-2 text-sm' : 'leading-6 text-22 mt-1'
            }`}
            isoCodeClasses="text-sm font-rp-pn-regular"
          />
        ) : null}
      </div>
    </div>
  );
}
